import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Download, Loader2 } from "lucide-react";
import { downloadAuthed } from "@/lib/api";
import { toast } from "sonner";

/**
 * Downloads an Excel file from `/api/exports/<key>.xlsx` using the cookie session.
 *
 * Props:
 *  - entity: 'indents' | 'pos' | 'grns' | 'invoices' | 'pvs'
 *  - filename: optional override for saved filename
 */
export default function ExportButton({ entity, filename, label = "Export to Excel", ...rest }) {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      await downloadAuthed(`/exports/${entity}.xlsx`, filename || `${entity}.xlsx`);
      toast.success("Export ready");
    } catch (e) {
      toast.error(`Export failed: ${e.message}`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      variant="outline"
      onClick={download}
      disabled={busy}
      data-testid={`export-${entity}-btn`}
      {...rest}
    >
      {busy ? <Loader2 size={14} className="mr-2 animate-spin" /> : <Download size={14} className="mr-2" />}
      {label}
    </Button>
  );
}
